import { useContext, useEffect, useMemo, useRef, useState } from "react";
import ToastContext from "../../../../src/contexts/toast";
import { RichiestaService } from "../../../services/RichiestaService";
import Select from "../../Form/Select";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import Modal from "../../Utility/Modal/Modal";
import { FormUtility } from "../../Utility/FormUtility";
import moment from "moment";

export default function ErroriProtocollo(props) {
  const toastContext = useContext(ToastContext);

  const [avviso, setAvviso] = useState(null);
  const [avvisi, setAvvisi] = useState(null);

  const richiestaService = new RichiestaService();

  const utility = new FormUtility();

  const [isModalOpen, setModalOpen] = useState(false);

  const [rescheduling, setRescheduling] = useState(false);

  const dtRefProtocollo = useRef();

  useEffect(() => {
    setAvvisi(props.avvisi);
  }, [props.avvisi]);

  const dtOptions = useMemo(() => {
    if (!avviso) return {};

    return {
      columns: [
        {
          name: "Id domanda",
          data: "id",
          visible: true,
          sortable: false,
          searchable: false,
        },
        {
          name: "Id Protocollo",
          data: "idProtocollo",
          visible: true,
          sortable: false,
          searchable: true,
        },
        {
          name: "Codice pratica",
          data: "codice",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "C.F. studente",
          data: "codiceFiscaleBeneficiario",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Errore",
          data: "erroreProtocollo",
          visible: true,
          sortable: true,
          searchable: true,
        }/* ,
        {
          name: "Data errore",
          data: "dataProtocollo",
          visible: true,
          sortable: true,
          searchable: false,
          cell: (row, col) => {
            if(row?.dataCreazioneProtocollo === null || row?.dataCreazioneProtocollo === 0) return "";
            return moment(row.dataCreazioneProtocollo).format("DD/MM/YYYY HH:mm:ss");
          }
        } */
      ],
      serverSide: true,
      ajax: richiestaService.getAllDt,
      ajaxParams: {
        bandoId: avviso,
        esitoProtocollo: "KO",
        statiRichiesta: ['PRESENTATA', 'ANNULLATA', 'RINUNCIATA', 'FINANZIABILE', 'NON_FINANZIABILE', 'SOSPESA', 'SOSPESA_TERZO_ACCESSO', 'AMMESSA_CONTRIBUTO','AMMESSA_CONTRIBUTO_RETTIFICATA', 'FINANZIABILE_TERZO_ACCESSO', 'NON_FINANZIABILE_TERZO_ACCESSO','FINANZIABILE_RETTIFICATA','AGGIORNATA','AGGIORNATA_TERZO_ACCESSO','RETTIFICATA']
      },
      rows: [],
      sorts: [],
      hideSearch: false,
      title: "Elenco errori",
    };
  }, [avviso]);

  const closeModal = async () => {
    setModalOpen(false);
  };

  const rescheduleProtocolli = () => {
    setRescheduling(true);
    richiestaService
      .rescheduleProtocolli(avviso)
      .then((resp) => {
        dtRefProtocollo.current.rerenderDatatable();
        toastContext.success(resp + " Protocolli rimessi in scheduling");
        setRescheduling(false);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setRescheduling(false);
      });
  };

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <Select
            classDiv={"rtds-mt-0 lg:rtds-mt-0"}
            label={"Avviso"}
            id={"avvisoProtocollo"}
            classSelect={""}
            onChange={(event) => {
              setAvviso(event.target.value ? event.target.value : null);
            }}
            baseOption={"Nessuna selezione"}
            bindKey={"id"}
            bindValue={"nome"}
            options={avvisi}
            value={avviso || ""}
          />
        </div>
      </div>

      {avviso && (
        <DataTableWrapper
          ref={dtRefProtocollo}
          dtOptions={dtOptions}
          reloadDatatable={true}
          headerButton={
            <button
              disabled={rescheduling}
              type="button"
              className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
              
              onClick={rescheduleProtocolli}
            >
              <svg
                className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-right`}
                />
              </svg>
              Riesegui i Protocolli
            </button>
          }
        />
      )}

      <Modal
        isOpen={isModalOpen}
        icona={true}
        onClose={() => closeModal()}
        actionLabel="Riesegui il protocollo"
        closeLabel="Chiudi"
      />
    </>
  );
}
